export const colors = {
  darkorange: 0xeb5200,
  orange: 0xfa9c55,
  green: 0x8cd261,
  mediumblue: 0x21abb5,
  blue: 0x4ec1c9,
  darkblue: 0x126973,
  gray: 0x888888
};
